import { DOCUMENT_NAMES } from "../constants/documents";

export function getDocumentRejectReason(loan, documentName, documentIndex = 0) {
  if (!loan) return "";

  const documents = loan.loan_documents;

  if (!documents) return "";

  const filteredDocuments = documents.filter((document) =>
    document.name.includes(documentName)
  );

  if (filteredDocuments.length === 0) return "";

  const matchedDocument = filteredDocuments[documentIndex];

  if (!matchedDocument || !matchedDocument.reject_reason) return "";

  return matchedDocument.reject_reason;
}

export function isStatementDocumentRejected(loan, documentIndex) {
  const statementDocuments = getStatementDocuments(loan);

  if (statementDocuments.length === 0) return false;

  const matchedDocument = statementDocuments[documentIndex];

  console.log(matchedDocument, documentIndex);

  return matchedDocument?.review_status === "reject";
}

export function isDocumentRejected(loan, documentName) {
  if (!loan) return false;

  const documents = loan.loan_documents;

  if (!documents) return false;

  const document = documents.find((document) =>
    document.name.includes(documentName)
  );

  return document && document.review_status === "reject";
}

export function getLoanDocuments(loan) {
  if (!loan) return [];

  return loan.loan_documents ?? [];
}

export function getStatementDocuments(loan) {
  if (!loan) return [];

  const documents = getLoanDocuments(loan);

  return documents.filter((document) =>
    document.name.includes(DOCUMENT_NAMES.STATEMENT)
  );
}
